import React, { useEffect } from "react";

import meetlyIcon from "../assets/Meetly-icon.png";
import meetlyLogo from "../assets/Meetly.png";

export default function Splash({ onFinish }) {
  useEffect(() => {
    // Set the duration of the splash screen
    const timer = setTimeout(() => {
      if (onFinish) onFinish();
    }, 5000);

    // Cleanup the timer if the component unmounts early
    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <div className="fixed inset-0 bg-[#F90669] z-[99999] flex flex-col items-center justify-between py-16 px-6 select-none animate-fadeIn">
      {/* Top spacer to vertically balance the layout */}
      <div />

      {/* Central icon with a smooth pulse animation */}
      <div className="flex items-center justify-center animate-pulse">
        <img
          src={meetlyIcon}
          alt="Meetly Icon"
          className="w-24 h-24 object-contain"
        />
      </div>

      {/* Bottom typography logo (color inverted to white) */}
      <div className="flex items-center justify-center mb-4">
        <img
          src={meetlyLogo}
          alt="Meetly Logo"
          className="w-28 object-contain filter brightness-0 invert"
        />
      </div>
    </div>
  );
}
